import type { MailboxInfo } from "owa-client-types";
import type { TableView } from "owa-mail-list-store";
import { tryGetMailboxInfoFromRowKeysOrIdsIfUnifiedInboxOrDefault } from "owa-mail-list-store";
import { type MenuItemType } from "owa-filterable-menu/lib/components/MenuItemType";
import { getMailMenuItemShouldHideForMailbox } from "../actions/getMailMenuItemShouldHideForMailbox";

/**
 * Determines whether Block/Never Block is supported for a Unified Inbox or multi-account search
 * selection. Blocking is supported only when the selection resolves to one mailbox that allows
 * the action.
 */
export function isBlockSupportedForUnifiedInboxOrMultiAccountSearchSelection(mailboxInfo: MailboxInfo, rowKeysOrIds: string[], tableView?: TableView): boolean {
    try {
        const resolvedMailboxInfo = tryGetMailboxInfoFromRowKeysOrIdsIfUnifiedInboxOrDefault(mailboxInfo, rowKeysOrIds, tableView);
        return !getMailMenuItemShouldHideForMailbox(5, resolvedMailboxInfo);
    }
    catch {
        // The selection spans multiple mailboxes (or none could be resolved).
        return false;
    }
}
